export default "__VITE_ASSET__BWuvgQ6M__"